import { vMaska } from 'maska/vue'

function normalizeMaskBinding (binding) {
  if (binding == null) {
    return binding
  }

  if (typeof binding.value === 'string' || Array.isArray(binding.value)) {
    return {
      ...binding,
      value: { mask: binding.value }
    }
  }

  return binding
}

export const mask = {
  mounted (el, binding) {
    vMaska(el, normalizeMaskBinding(binding))
  },
  updated (el, binding) {
    vMaska(el, normalizeMaskBinding(binding))
  }
}

export default mask
